import { AppConsts } from '@/abpPro/AppConsts';
import { rootRouting } from '@/router';
import { abpService } from '@/shared/abp/';
import { UrlHelper } from '@/shared/helpers/UrlHelper';
import { AuthenticateModel, AuthenticateResultModel, AutoLoginRequest, TokenAuthServiceProxy } from '@/shared/service-proxies';
import { apiHttpClient } from '@/shared/utils';
import axios from 'axios';
import * as _ from 'lodash';

class LoginService {
    public authenticateModel: AuthenticateModel = new AuthenticateModel();
    public AutoLoginRequest: AutoLoginRequest = new AutoLoginRequest();
    public authenticateResult: AuthenticateResultModel;
    public rememberMe: boolean;
    public _tokenAuthService: TokenAuthServiceProxy;

    constructor() {
        this._tokenAuthService = new TokenAuthServiceProxy(AppConsts.remoteServiceBaseUrl, apiHttpClient);
    }

    public authenticate(successCallback?, errorCallback?: () => void, finallyCallback?: () => void, redirectUrl?: string) {
        this._tokenAuthService
            .authenticateToNew(this.authenticateModel)
            .finally(() => {
                finallyCallback();
            })
            .catch((err) => {
                errorCallback();
                return err;
            })
            .then((result) => {
                successCallback(result);
                this.processAuthenticateResult(result, redirectUrl);
            });
    }

    public authenticateToDomain(successCallback?, errorCallback?: () => void, finallyCallback?: () => void, redirectUrl?: string) {

        // 向服务器发送请求，获取当前用户信息
        axios.get(AppConsts.remoteServiceBaseUrl + '/api/TokenAuth/WhoAmI/whoami', { withCredentials: true })
            .then(response => {
                console.log(response);
                // 获取当前用户名
                const domainUser = response.data.result.username;
                console.log(domainUser);
                this.AutoLoginRequest.domainUser = domainUser;
                this._tokenAuthService
                    .autoLogin(this.AutoLoginRequest)
                    .finally(() => {
                        finallyCallback();
                    })
                    .catch((err) => {
                        errorCallback();
                        return err;
                    })
                    .then((result) => {
                        successCallback(result);
                        this.processAuthenticateResult(result, redirectUrl);
                    });

                // // 向服务器发送请求，自动登录
                // return axios.post(AppConsts.remoteServiceBaseUrl + '/api/TokenAuth/AutoLogin/autologin', { domainUser: domainUser, TenantId: abpService.abp.multiTenancy.getTenantIdCookie() });
            })
            .then(response => {
                // console.log(response);
                // // 获取token
                // const token = response.data.token;
                // // 将token存储在localStorage中
                // localStorage.setItem("token", token);
                // // 设置axios的默认请求头，添加token
                // axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            })
            .catch(err => {
                console.error('自动登录失败', err);
                //执行erro     rCallback
                errorCallback();
                return err;
            })
            .finally(() => {
                // 执行finallyCallback
                finallyCallback();
            })
            ;

        // // 调用_tokenAuthService的authenticateToNew方法，进行认证
        // this._tokenAuthService
        // 	.authenticateToNew(this.authenticateModel)
        // 	.finally(() => {
        // 		// 执行finallyCallback
        // 		finallyCallback();
        // 	})
        // 	.catch((err) => {
        // 		// 执行errorCallback
        // 		errorCallback();
        // 		return err;
        // 	})
        // 	.then((result) => {
        // 		// 执行successCallback
        // 		successCallback(result);
        // 		// 处理认证结果
        // 		this.processAuthenticateResult(result, redirectUrl);
        // 	});
    }

    public authenticateToLdap(successCallback?, errorCallback?: () => void, finallyCallback?: () => void, redirectUrl?: string) {
        this._tokenAuthService
            .authenticateToLdap(this.authenticateModel)
            .finally(() => {
                finallyCallback();
            })
            .catch((err) => {
                errorCallback();
                return err;
            })
            .then((result) => {
                successCallback(result);
                this.processAuthenticateResult(result, redirectUrl);
            });
    }

    private processAuthenticateResult(authenticateResult: AuthenticateResultModel, redirectUrl?: string) {

        if (authenticateResult.waitingForActivation) {

            rootRouting.push({
                path: 'account/activation',
                params: {
                    state: authenticateResult.toJSON(),
                },
            });
        } else if (authenticateResult.accessToken) {

            const ssoGuidExpireDate = authenticateResult.expireInSeconds
                ? new Date(new Date().getTime() + 1000 * authenticateResult.expireInSeconds)
                : undefined;
            //写入SSOG     uid,设置与token相同的过期时间
            abpService.abp.utils.setCookieValue('SSOGuid', authenticateResult.ssoGuid, ssoGuidExpireDate, abp.appPath);
            this.login(
                authenticateResult.accessToken,
                authenticateResult.encryptedAccessToken,
                authenticateResult.expireInSeconds,
                this.rememberMe
            );
        } else {
            abpService.abp.log.warn('Unexpected authenticateResult!');
        }
    }

    private login(
        accessToken: string,
        encryptedAccessToken: string,
        expireInSeconds: number,
        rememberMe?: boolean,
        twoFactorRememberClientToken?: string,
        redirectUrl?: string
    ): void {
        const tokenExpireDate = rememberMe ? new Date(new Date().getTime() + 1000 * expireInSeconds) : undefined;

        abpService.abp.auth.setToken(accessToken, tokenExpireDate);

        abpService.abp.utils.setCookieValue(
            AppConsts.authorization.encrptedAuthTokenName,
            encryptedAccessToken,
            tokenExpireDate,
            abp.appPath
        );

        let initialUrl = UrlHelper.initialUrl;
        if (initialUrl.indexOf('/login') > 0) {
            initialUrl = AppConsts.appBaseUrl;
        }

        location.href = initialUrl;
    }

    public getReturnUrl(): string {
        return UrlHelper.getReturnUrl();
    }
}

const loginService = new LoginService();

export { loginService };
